import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';
import { utmParams, utmVisitedTimeParam } from '~/javascripts/utils/params';

const createUtm30DayCookie = () =>
  Cookies.set('maji_utm', cookieParams(), {
    expires: 30,
  });

const utm30DayCookie = () => Cookies.get('maji_utm');

const manageUtm30DayCookie = () => {
  if (utm30DayCookie() !== undefined || isEmpty(utmParams())) {
    return false;
  } else {
    createUtm30DayCookie();
  }
};

const cookieParams = () => ({
  ...utmParams(),
  ...utmVisitedTimeParam(),
});

const createOrUpdateUtmSessionCookie = () =>
  Cookies.set('utm_session', cookieParams());

const manageUtmSessionCookie = () => {
  if (isEmpty(utmParams())) return false;

  createOrUpdateUtmSessionCookie();
};

const manageUtmCookie = () => {
  manageUtm30DayCookie();
  manageUtmSessionCookie();
};

export default manageUtmCookie;
